"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelVersionsRef = exports.projectsByWorkspace = exports.modelVersionFilePathByCategory = exports.modelVersionFilesPathByProject = exports.modelVersionRefByProject = exports.modelVersionFilesPublishedPathByTask = exports.modelVersionFilesPathByTask = exports.modelVersionRefByTask = exports.taskHistoryRef = exports.modelVersionFullPathByTask = exports.projectRefByTask = void 0;
exports.projectRefByTask = ({ orgId, userId, projectId }) => {
    return `orgData/${orgId}/projects/${userId}/${projectId}`;
};
exports.modelVersionFullPathByTask = ({ orgId, userId, modelId, modelVersionOrdKey }) => {
    return `modelVersion/${orgId}/${userId}/${modelId}/${modelVersionOrdKey}`;
};
exports.taskHistoryRef = (taskId) => {
    return `taskHistory/${taskId}`;
};
exports.modelVersionRefByTask = ({ orgId, userId, modelId, modelVersionOrdKey }) => {
    return `orgData/${orgId}/models/${userId}/${modelId}/modelVersions/${modelVersionOrdKey}`;
};
exports.modelVersionFilesPathByTask = (task) => {
    return `modelVersion/${task.orgId}/${task.userId}/${task.modelId}/${task.modelVersionOrdKey}`;
};
exports.modelVersionFilesPublishedPathByTask = (task) => {
    return `${exports.modelVersionFilesPathByTask(task)}/published`;
};
exports.modelVersionRefByProject = ({ orgId, userIdOrWorkspace, project, modelVersionOrdKey }) => {
    return `orgData/${orgId}/models/${userIdOrWorkspace}/${project.modelId}/modelVersions/${modelVersionOrdKey}`;
};
exports.modelVersionFilesPathByProject = ({ orgId, userIdOrWorkspace, project, modelVersionOrdKey }) => {
    return `modelVersion/${orgId}/${userIdOrWorkspace}/${project.modelId}/${modelVersionOrdKey}`;
};
//TODO - fix preview path to include taskId
exports.modelVersionFilePathByCategory = ({ category, base, fileId, fileGroup }) => {
    switch (category) {
        case "assetBundle": {
            return `${base}/files/${fileGroup === "preview" ? "previews/NATIVE" : "published"}/assetBundle/${fileId}`;
        }
        case "media": {
            return `${base}/files/${fileGroup === "preview" ? "previews/NATIVE" : "published"}/media/${fileId}`;
        }
        case "model": {
            return `${base}/files/original/model/${fileId}`;
        }
        case "misc": {
            return `${base}/files/original/misc/${fileId}`;
        }
        default: {
            return null;
        }
    }
};
exports.projectsByWorkspace = (orgId, userIdOrWorkspace) => `orgData/${orgId}/projects/${userIdOrWorkspace}`;
exports.modelVersionsRef = (orgId, userIdOrWorkspace, modelId) => `orgData/${orgId}/models/${userIdOrWorkspace}/${modelId}/modelVersions/`;
//# sourceMappingURL=refs.js.map